import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { CheckCircle2, UtensilsCrossed, ShoppingCart, ClipboardCheck } from 'lucide-react';
export function WhatsInside() {
  const recipes = [{
    title: 'El Sartén de Pollo y Cúrcuma (15 min)',
    desc: 'Proteína limpia que repara músculos sin crear pesadez.',
    ingredients: 'Pechuga picada, brócoli, ajo y mucha cúrcuma.'
  }, {
    title: "Sopa 'Tobillos Ligeros' (Pescado y Coco)",
    desc: 'El Omega-3 desinflama tus manos y pies mientras descansas.',
    ingredients: 'Filete de pescado blanco, leche de coco, calabacín, jengibre.'
  }, {
    title: "Picadillo de Pavo 'Cero Inflamación'",
    desc: 'Alto en magnesio para un sueño profundo y reparador.',
    ingredients: 'Pavo molido, pimientos rojos, cebolla, espinacas frescas.'
  }];
  return <section className="py-20 px-4 bg-[#FFF8E7]" data-id="element-123">
      <div className="max-w-6xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5C3D2E] mb-6" data-id="element-126">
            ¿Qué encontrarás dentro de esta guía?
          </h2>
          <p className="text-xl text-[#5C3D2E] max-w-3xl mx-auto" data-id="element-127">
            Todo lo que necesitas para transformar tus cenas en medicina, sin
            complicaciones.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-128">
          {/* Recipes Column */}
          <div className="space-y-6" data-id="element-129">
            <div className="flex items-center gap-3 mb-8" data-id="element-130">
              <UtensilsCrossed className="w-8 h-8 text-[#D4A017]" data-id="element-131" />
              <h3 className="text-2xl font-bold text-[#5C3D2E]" data-id="element-132">
                El Recetario Maestro
              </h3>
            </div>

            {recipes.map((recipe, index) => <Card key={index} delay={index * 0.1} className="p-6 border-l-4 border-l-[#D4A017]" data-id="element-133">
                <h4 className="text-xl font-bold text-[#5C3D2E] mb-2" data-id="element-134">
                  {recipe.title}
                </h4>
                <p className="text-[#5B7A3A] font-medium mb-3" data-id="element-135">{recipe.desc}</p>
                <p className="text-sm text-[#5C3D2E] opacity-80" data-id="element-136">
                  <strong data-id="element-137">Ingredientes clave:</strong> {recipe.ingredients}
                </p>
              </Card>)}
          </div>

          {/* Bonuses Column */}
          <div className="space-y-8" data-id="element-138">
            <Card delay={0.4} className="p-8 bg-white border-2 border-[#5B7A3A]/20" data-id="element-139">
              <div className="flex items-center gap-3 mb-6" data-id="element-140">
                <ClipboardCheck className="w-8 h-8 text-[#5B7A3A]" data-id="element-141" />
                <h3 className="text-2xl font-bold text-[#5C3D2E]" data-id="element-142">
                  Tu Tablero de Control Diario
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-143">
                {['¿Usé una sola olla para cocinar hoy?', '¿Incluí al menos uno de los 5 soldados curativos?', '¿Cené antes de las 7:30 PM para dar tiempo a la digestión?', 'Mañana al despertar: ¿siento menos rigidez en las manos?'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-144">
                    <CheckCircle2 className="w-6 h-6 text-[#5B7A3A] flex-shrink-0 mt-1" data-id="element-145" />
                    <span className="text-lg text-[#5C3D2E]" data-id="element-146">{item}</span>
                  </li>)}
              </ul>
            </Card>

            <Card delay={0.5} className="p-8 bg-[#FFFDF5] border-2 border-[#C67B5C]/20" data-id="element-147">
              <div className="flex items-center gap-3 mb-6" data-id="element-148">
                <ShoppingCart className="w-8 h-8 text-[#C67B5C]" data-id="element-149" />
                <h3 className="text-2xl font-bold text-[#5C3D2E]" data-id="element-150">
                  Lista de Compras "Smart"
                </h3>
              </div>
              <p className="text-lg text-[#5C3D2E] mb-4" data-id="element-151">
                Adaptada para supermercados en USA. Incluye:
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-152">
                {['Arroz de Coliflor congelado', "Pechugas 'No Antibiotics'", 'Espinaca pre-lavada', 'Cúrcuma en polvo', 'Leche de coco sin azúcar'].map((item, i) => <li key={i} className="flex items-center gap-2 text-[#5C3D2E]" data-id="element-153">
                    <div className="w-2 h-2 rounded-full bg-[#C67B5C]" data-id="element-154" />
                    <span data-id="element-155">{item}</span>
                  </li>)}
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}